import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/view/home'
import IntroAutobi from '@/view/intro_autobi'
import IntroAutoCloud from '@/view/intro_autocloud'
import IntroRecommand from '@/view/intro_recommand'
import introZhibo from '@/view/intro_zhibo'
import introPush from '@/view/intro_push'
import introFlashback from '@/view/intro_flashback'
import introPlayer from '@/view/intro_player'
/* eslint-disable */
Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage,
      meta: {
        title: '之家科技产品_助力企业发展',
        pv: {category: 1728}
      }
    },
    {
      path: '/introAutobi',
      name: 'IntroAutobi',
      component: IntroAutobi,
      meta: {
        title: 'AutoBI_之家科技产品',
        pv: {category: 1724}
      }
    },
    {
      path: '/introAutoCloud',
      name: 'IntroAutoCloud',
      component: IntroAutoCloud,
      meta: {
        title: '之家云_之家科技产品',
        pv: {category: 1723}
      }
    },
    {
      path: '/introRecommand',
      name: 'introRecommand',
      component: IntroRecommand,
      meta: {
        title: '搜索推荐平台_之家科技产品',
        pv: {category: 1725}
      }
    },
    {
      path: '/introZhibo',
      name: 'introZhibo',
      component: introZhibo,
      meta: {
        title: '视频直播_之家科技产品',
        pv: {category: 1726}
      }
    },
    {
      path: '/introPush',
      name: 'introPush',
      component: introPush,
      meta: {
        title: '推送平台_之家科技产品',
        pv: {category: 1722}
      }
    },
    {
      path: '/introFlashback',
      name: 'introFlashback',
      component: introFlashback,
      meta: {
        title: '闪退采集工具_之家科技产品',
        pv: { category: 1727 }
      }
    },
    {
      path: '/introPlayer',
      name: 'introPlayer',
      component: introPlayer,
      meta: {
        title: '播放器_之家科技产品',
        pv: { category: 1721 }
      }
    }
  ]
})

/* eslint-disable */
router.beforeEach((to, from, next) => {
   /* 路由发生变化修改页面title */
   if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js